import { restaurantItemTemplate } from '../../templates/template-creator'

class FavoredRestaurantView {
  getTemplate () {
    return `
      <div class="content">
        <h2 class="content__heading">Your Favored Restaurant</h2>
        <div id="restaurants" class="restaurants"></div>
      </div>
    `
  }

  showFavoriteRestaurants(restaurants = []) {
    let html
    if (restaurants.length) {
      html = restaurants.reduce((carry, restaurant) => carry.concat(restaurantItemTemplate(restaurant)), '')
    } else {
      html = this._getEmptyRestaurantTemplate()
    }

    document.getElementById('restaurants').innerHTML = html
    document.getElementById('restaurants').dispatchEvent(new Event('restaurants:updated'))
  }

  _getEmptyRestaurantTemplate () {
    return '<div class="restaurants__empty">Restaurant Not Found</div>'
  }
}

export default FavoredRestaurantView
